// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3RpQE","list":"BalanceDue_list__30PB6","listRow":"BalanceDue_listRow__2RoY3","total":"BalanceDue_total__T192b"};